import { render } from "./PrivacypolicypageCom.vue?vue&type=template&id=66a1d99d&scoped=true"
import script from "./PrivacypolicypageCom.vue?vue&type=script&lang=js"
export * from "./PrivacypolicypageCom.vue?vue&type=script&lang=js"

import "./PrivacypolicypageCom.vue?vue&type=style&index=0&id=66a1d99d&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66a1d99d"]])

export default __exports__